import Constants from '@/constants/constants';
import axios from 'axios';


function formatWithThousandsSeparator(num){
  const n = typeof num === "number" ? num.toString() : num;
  if (isNaN(Number(n))||n===0) return "--";
  const [integer, decimal] = n.split(".");
  const reg = /\d{1,3}(?=(\d{3})+$)/g;
  const n1 = integer.replace(reg, "$&,");
  return decimal ? `${n1}.${decimal}` : n1;
}
class Session {
  static setItem(key, value) {
    sessionStorage.setItem(key, typeof value !== 'string' ? JSON.stringify(value) : value);
  }

  static hasItem(key) {
    return !!sessionStorage.getItem(key);
  }

  static getItem(key) {
    const value = sessionStorage.getItem(key);
    return value;
  }

  static removeItem(key) {
    sessionStorage.removeItem(key);
  }

  static getObject(key) {
    let value = sessionStorage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (error) {
      return value;
    }

    return value;
  }
}

class Local {
  static setItem(key, value) {
    localStorage.setItem(key, typeof value !== 'string' ? JSON.stringify(value) : value);
  }

  static hasItem(key) {
    return !!localStorage.getItem(key);
  }

  static getItem(key) {
    const value = localStorage.getItem(key);
    return value;
  }

  static removeItem(key) {
    localStorage.removeItem(key);
  }

  static getObject(key) {
    let value = localStorage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (error) {
      return value;
    }

    return value;
  }
}

export default class Utils {
  static Session = Session;
  static Local = Local;

  static getBrowserInfo() {
    try {
      let ua = navigator.userAgent;
      let tem;
      let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[:]+(\d+)/g.exec(ua) || [];
        return `IE${tem[1] || ''}`;
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem !== null) {
          return `Opera${tem[1]}`;
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
        M.splice(1, 1, tem[1]);
      }
      return `${M[0]}${M[1]}`;
    } catch (error) {
      return 'Unknown';
    }
  }

  static getOSInfo() {
    let osInfo = { name: 'Unknown', version: 'Unknown' };
    let userAgent = navigator.userAgent.toLowerCase();
    try {
      if (userAgent.indexOf('win') > -1) {
        osInfo.name = 'Windows';
        if (userAgent.indexOf('windows nt 5.0') > -1) {
          osInfo.version = 'Windows 2000';
        } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
          osInfo.version = 'Windows XP';
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
          osInfo.version = 'Windows Vista';
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
          osInfo.version = 'Windows 7';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
          osInfo.version = 'Windows 8';
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
          osInfo.version = 'Windows 8.1';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
          osInfo.version = 'Windows 10';
        } else {
          osInfo.version = 'Unknown';
        }
      } else if (userAgent.indexOf('iphone') > -1) {
        osInfo.name = 'Iphone';
      } else if (userAgent.indexOf('mac') > -1) {
        osInfo.name = 'Mac';
      } else if (
        userAgent.indexOf('x11') > -1 ||
        userAgent.indexOf('unix') > -1 ||
        userAgent.indexOf('sunname') > -1 ||
        userAgent.indexOf('bsd') > -1
      ) {
        osInfo.name = 'Unix';
      } else if (userAgent.indexOf('linux') > -1) {
        if (userAgent.indexOf('android') > -1) {
          osInfo.name = 'Android';
        } else {
          osInfo.name = 'Linux';
        }
      } else {
        osInfo.name = 'Unknown';
      }
      return `${osInfo.name}: ${osInfo.version}`;
    } catch (error) {
      return 'Unknown';
    }
  }

  static lowercaseAlphanumericCharactersOnly(value) {
    return /^[a-z][a-z0-9]+$/.test(value);
  }

  static isAlphanumericCharactersOnly(value) {
    return /^[a-z0-9]+$/i.test(value);
  }

  static isNumericCharactersOnly(value) {
    return /^[0-9]+$/i.test(value);
  }

  static isValidEmail(value) {
    return /^\w+([\.\-]\w+)*\@\w+([\.\-]\w+)*\.\w+$/.test(value);
  }

  static isValidPhoneNumber(value) {
    return /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(
      value
    );
  }

  static hasDangerousCharacters(value) {
    return /[_<>$*=/\\]/.test(value);
  }
  static isHttp(value) {
    return /(http|https):\/\/([\w.]+\/?)\S*/.test(value);
  }
  static isUndefined(value) {
    return typeof value === 'undefined';
  }

  static validateVersionNumber(value) {
    return /^(\w+?(\.|-|_))+?\w+?$/.test(value);
  }
  // 正整数
  static validatePositiveInt(value) {
    return /(^[1-9]\d*$)/.test(value);
  }
  // 验证特殊字符
  // static validateSpecialStr(value) {
  //     return /^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(value);
  // }
  // 验证版本号是否输入正确1.0.1
  static validateVersion(value) {
    // return /^([1-9]\d|[1-9])(.([0-9]\d|\d))+$/.test(value);
    return /^([1-9]\d|[1-9])(.([0-9]\d|\d)){2}$/.test(value);
  }
  static getSetParameters(obj, path) {
    const nameParts = Utils.generatePathKeys(path);
    const key = nameParts.pop();
    let current = obj;
    for (const key of nameParts) {
      current = current[key];
    }
    return { current, key };
  }

  static generatePathKeys(path) {
    const nameParts = path.split('.');
    // const length = nameParts.length;
    // for (let i = length - 1; i >= 0; i--) {
    //     let key = nameParts[i];
    //     const matches = key.match(/(?<=\[)\d*(?=\])/g);
    //     if (matches) {
    //         nameParts.splice(i + 1, 0, ...matches);
    //         nameParts[i] = key.replace(/\[\d+\]/g, '');
    //     }
    // }
    return nameParts;
  }

  static get(path, object) {
    const nameParts = Utils.generatePathKeys(path);
    let current = object;
    for (const key of nameParts) {
      current = current[key];
    }
    return current;
  }
  static shouldGoPreviousPage(total, pageIndex, pageSize) {
    return total % pageSize === 1 && pageIndex === Math.ceil(total / pageSize);
  }

  static isObjectValueEqual(a, b) {
    try {
      //  取对象a和b的属性名
      let aProps = Object.getOwnPropertyNames(a);
      let bProps = Object.getOwnPropertyNames(b);
      //  判断属性名的length是否一致
      if (aProps.length !== bProps.length) {
        return false;
      }
      //  循环取出属性名，再判断属性值是否一致
      for (let i = 0; i < aProps.length; i++) {
        let propName = aProps[i];
        if (propName !== '__ob__') {
          if (a[propName] !== b[propName]) {
            return false;
          }
        }
      }
      return true;
    } catch (error) {
      return false;
    }
  }
  static isArrValueEqual(a, b) {
    try {
      if (JSON.stringify(a.sort()) === JSON.stringify(b.sort()) && a.length === b.length) {
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }
  static debounce(fn, delay) {
    let timeout = null;
    let wait = delay || 600;
    return function () {
      // eslint-disable-next-line
      let that = this;
      if (timeout !== null) clearTimeout(timeout);
      return new Promise((resolve, reject) => {
        timeout = setTimeout(async () => {
          try {
            const result = await fn.apply(that, arguments);
            resolve(result);
          } catch (error) {
            reject(error);
          }
        }, wait);
      });
    };
  }

  static removeArrayItem(array, predict) {
    const index = array.findIndex(predict);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  static validateUserPassword(value) {
    if (value.includes(' ')) {
      return '密码不能包含空格';
    } else if (value.length < 5) {
      return '密码长度必须大于等于5';
    } else {
      return '';
    }
  }

  static getHttpHostPort() {
    if (window.customHost) {
      return window.customHost;
    } else {
      return '';
    }
  }

  static getWsHostPort() {
    if (window.customHost) {
      return window.customHost.replace('https', 'wss').replace('http', 'ws');
    }
    const loc = window.location;
    let new_uri;
    if (loc.protocol === 'https:') {
      new_uri = 'wss:';
    } else {
      new_uri = 'ws:';
    }

    let host = loc.host;
    // 解决二级目录问题
    const pathArray = loc.pathname.split('/');
    if (pathArray.length > 2) {
      pathArray.pop();
      host += pathArray.join('/');
    }

    new_uri += '//' + host;
    return new_uri;
  }

  static urlCheck(url) {
    const strRegex =
      '^((https|http|ftp|rtsp|mms)?://)' +
      "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" +
      // IP形式的URL- 199.194.52.184
      '(([0-9]{1,3}.){3}[0-9]{1,3}' +
      // 允许IP和DOMAIN（域名）
      '|' +
      // 域名- www.
      "([0-9a-z_!~*'()-]+.)*" +
      // 二级域名
      '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' +
      // first level domain- .com or .museum
      '[a-z]{2,6})' +
      // 端口- :80
      '(:[0-9]{1,4})?' +
      // a slash isn't required if there is no file name
      '((/?)|' +
      "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";

    const re = new RegExp(strRegex);
    return re.test(url);
  }
  static checkMavenUrl(url) {
    const strRegex =
      '^(https|http|ftp|rtsp|mms)://' +
      "(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" +
      '(([0-9]{1,3}.){3}[0-9]{1,3}' +
      // IP形式的URL- 199.194.52.184
      '|' +
      // 允许IP和DOMAIN（域名）
      "([0-9a-z_!~*'()-]+.)*" +
      // 域名- www.
      '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' +
      // 二级域名
      '[a-z]{2,6})' +
      // first level domain- .com or .museum
      '(:[0-9]{1,4})?' +
      // 端口- :80
      '((/?)|' +
      // a slash isn't required if there is no file name
      "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";

    const re = new RegExp(strRegex);
    return re.test(url);
  }
  /*将字符串转换成date格式*/
  static date(str) {
    if (!str || str.length < 8) return null;
    if (str.length == 8) {
      str = str.substring(0, 4) + '-' + str.substring(4, 6) + '-' + str.substring(6, 8);
    }
    var e =
      'new Date(' +
      str
        .replace(/\d+(?=-[^-]+$)/, function (a) {
          return parseInt(a, 10) - 1;
        })
        .replace(/\d+/g, function (a) {
          return parseInt(a, 10);
        })
        .match(/\d+/g) +
      ')';

    var date = eval(e);
    return date;
  }

  /*将日期格式化字符串*/
  static dateFormat(date, formatStr) {
    var str = formatStr;
    var Week = ['日', '一', '二', '三', '四', '五', '六'];

    str = str.replace(/yyyy|YYYY/, date.getFullYear());
    str = str.replace(
      /yy|YY/,
      date.getYear() % 100 > 9 ? (date.getYear() % 100).toString() : '0' + (date.getYear() % 100)
    );

    var month = date.getMonth() + 1;
    str = str.replace(/MM/, month > 9 ? month.toString() : '0' + month);
    str = str.replace(/M/g, month);

    str = str.replace(/w|W/g, Week[date.getDay()]);

    str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
    str = str.replace(/d|D/g, date.getDate());

    str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
    str = str.replace(/h|H/g, date.getHours());
    str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
    str = str.replace(/m/g, date.getMinutes());

    str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
    str = str.replace(/s|S/g, date.getSeconds());

    return str;
  }

  static dateAdd(interval, number, date) {
    /*
     *---------------  DateAdd(interval,number,date)  -----------------
     *  DateAdd(interval,number,date)
     *  参数:interval,字符串表达式，表示要添加的时间间隔.
     *  参数:number,数值表达式，表示要添加的时间间隔的个数.
     *  参数:date,时间对象.
     *  返回:新的时间对象.
     *  var  now  =  new  Date();
     *  var  newDate  =  DateAdd( "d ",5,now);
     */
    number = isNaN(number) ? 0 : parseInt(number);
    switch (interval) {
      case 'y': {
        date.setFullYear(date.getFullYear() + number);
        return date;
        break;
      }
      case 'q': {
        date.setMonth(date.getMonth() + number * 3);
        return date;
        break;
      }
      /*报告期*/
      case 'r': {
        var day = date.getDate();
        date.setDate(1);
        var dayInfo = {
          0: { 0: 31, 1: 28, 2: 31, 3: 30, 4: 31, 5: 30, 6: 31, 7: 31, 8: 30, 9: 31, 10: 30, 11: 31 },
          1: { 0: 31, 1: 29, 2: 31, 3: 30, 4: 31, 5: 30, 6: 31, 7: 31, 8: 30, 9: 31, 10: 30, 11: 31 }
        };

        date.setMonth(date.getMonth() + number * 3);
        var newYear = date.getFullYear();
        var newMonth = date.getMonth();
        var result = (newYear % 4 == 0 && newYear % 100 != 0) || newYear % 400 == 0 ? 1 : 0;
        var maxDays = dayInfo[result][newMonth];
        var newDay = maxDays;
        date.setDate(newDay);
        return date;
        break;
      }
      case 'm': {
        var day = date.getDate();
        date.setDate(1);
        var dayInfo = {
          0: { 0: 31, 1: 28, 2: 31, 3: 30, 4: 31, 5: 30, 6: 31, 7: 31, 8: 30, 9: 31, 10: 30, 11: 31 },
          1: { 0: 31, 1: 29, 2: 31, 3: 30, 4: 31, 5: 30, 6: 31, 7: 31, 8: 30, 9: 31, 10: 30, 11: 31 }
        };
        date.setMonth(date.getMonth() + number);
        var newYear = date.getFullYear();
        var newMonth = date.getMonth();
        var result = (newYear % 4 == 0 && newYear % 100 != 0) || newYear % 400 == 0 ? 1 : 0;
        var maxDays = dayInfo[result][newMonth];
        var newDay = day;
        if (newDay > maxDays) {
          newDay = maxDays;
        }
        date.setDate(newDay);

        return date;
        break;
      }
      case 'w': {
        date.setDate(date.getDate() + number * 7);
        return date;
        break;
      }
      case 'd': {
        date.setDate(date.getDate() + number);
        return date;
        break;
      }
      case 'h': {
        date.setHours(date.getHours() + number);
        return date;
        break;
      }
      case 'min': {
        date.setMinutes(date.getMinutes() + number);
        return date;
        break;
      }
      case 's': {
        date.setSeconds(date.getSeconds() + number);
        return date;
        break;
      }
      default: {
        date.setDate(date.getDate() + number);
        return date;
        break;
      }
    }
  }
  static formatDateTime(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const dateNumber = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}/${month}/${dateNumber} ${hours}:${minutes}:${seconds}`;
  }

  static checkIfReservedKeyword(str) {
    let arr = Constants.keywords.map(word => {
      return word.toLowerCase();
    });
    return arr.includes(str.toLowerCase());
  }
  static downloadFile(data, url, defaultFileName, downloadProgressCallback) {
    let LastDecision = Utils.Local.getObject(Constants.ProjectManagement.LastDecision);
    const options = {
      method: Constants.http.Methods.Post,
      headers: {
        [Constants.http.HeaderKeys.ContentType]: Constants.http.HeaderValues.ApplicationJson,
        sysNo: LastDecision?.sysNo,
        sysVersionNo: LastDecision?.sysVersionNo,
        sysPlatformNo: LastDecision?.sysPlatformNo,
        Authorization:
          (window.__POWERED_BY_QIANKUN__ ? '' : 'Bearer ') + Utils.Local.getItem(Constants.UsersManagement.Token)
      },
      data: data,
      url: Utils.getHttpHostPort() + url,
      responseType: Constants.http.ResponseTypes.Blob
    };
    if (typeof downloadProgressCallback === 'function') {
      options.onDownloadProgress = downloadProgressCallback;
    }
    return axios(options).then(async response => {
      return new Promise((resolve, reject) => {
        const data = response.data;
        const type = response.data.type;
        if (data.size === 0) {
          reject(new Error('空文件'));
        } else if (type !== Constants.http.HeaderValues.ApplicationJson) {
          // 下载正常处理
          const cd = response.headers[Constants.http.HeaderKeys.ContentDisposition];
          let filename;
          if (cd) {
            let filenameItem = cd.split(';').find(i => i.startsWith('filename='));
            filename = filenameItem.replace(/filename=/, '');
          }
          filename = decodeURI(filename) || defaultFileName;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          resolve();
        } else {
          const r = new FileReader();
          r.onload = function (event) {
            const jsonData = JSON.parse(r.result);
            try {
              if (jsonData.internalCode !== Constants.http.InternalCodes.OK) {
                return reject(new Error(jsonData.errorInfo || '下载失败'));
              }
            } catch (err) {}
          };
          r.readAsText(data);
        }
      });
    });
  }

  static isFunction(value) {
    return typeof value === 'function';
  }
  static downloadImage(blob) {
    let url = window.URL.createObjectURL(blob);
    let filename = '流程图.png';

    let a = document.createElement('a');
    a.style = 'display: none';
    a.href = url;
    a.download = filename;

    // IE 11
    if (window.navigator.msSaveBlob !== undefined) {
      window.navigator.msSaveBlob(blob, filename);
      return;
    }

    document.body.appendChild(a);
    requestAnimationFrame(function () {
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }
  static formatList(value) {
    let rootList;
    let sysDictRoutes = sessionStorage.getItem('sysDictRoutes')
      ? JSON.parse(sessionStorage.getItem('sysDictRoutes'))
      : [];
    for (let i = 0; i < sysDictRoutes.length; i++) {
      if (sysDictRoutes[i].sysDictCode === value) {
        rootList = sysDictRoutes[i];
      }
    }
    return rootList;
  }
  static getHexOpacityColor({ defaultColor = '#000', defaultOpacity = 0.5 }) {
    let opacity = Math.max(defaultOpacity, 0);
    opacity = Math.min(defaultOpacity, 1);
    let color = defaultColor.replace(/\#/g, '').toUpperCase();
    if (color.length === 3) {
      let arr = color.split('');
      color = '';
      for (let i = 0; i < arr.length; i++) {
        color += arr[i] + arr[i];
        //将简写的3位字符补全到6位字符
      }
    }
    let num = Math.round(255 * opacity);
    //四舍五入
    let str = '';
    let arrHex = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
    //十六进制数组
    while (num > 0) {
      let mod = num % 16;
      num = (num - mod) / 16;
      str = arrHex[mod] + str;
    }
    if (str.length === 1) str = '0' + str;
    if (str.length === 0) str = '00';
    return `#${color + str}`;
  }
  static handlePropData(data) {
    let dataValues = [];
    for (let i = 0; i < data.length; i++) {
      let d = data[i];
      let dataValue = {
        propNo: d.propNo,
        label: '',
        value: {},
        disabled: d.forUsed,
        forUsed: d.forUsed,
        propType: d.propType || d.dictRootType,
        dictType: d.dictType || d.propType || d.dictRootType,
        propName: d.propName,
        propCode: d.propCode
      };
      dataValue.key = '{"propNo":"' + d.propNo + '","propType":"' + d.propType + '"}';
      d.propType = d.propType || d.dictRootType;
      d.dictType = d.dictType || d.propType || d.dictRootType;
      dataValue.label =
        d.propName +
        ' | ' +
        d.propCode +
        ' | ' +
        d.dictType.split('.')[d.dictType.split('.').length - 1] +
        ' | ' +
        (d?.propDesc || '');
      dataValues.push(dataValue);
    }
    return dataValues;
  }
  static getToken() {
    let cookie = document.cookie.replace(/ /,''),token = '';
    if (cookie) {
      const tokenRegex = /^token/
      let findToken = cookie.split(';').map(item=>item.trim()).find(key=>tokenRegex.test(key))
      if(findToken){
        token=findToken.replace(/token=/,'')
      }
    }
    return token;
  }
  /*获取url里面的参数*/
  static getUrlParam() {
    var htmlParam = location.search.substring(1);
    var htmlArray = htmlParam.split('&');
    var objData = {};

    for (var row = 0; row < htmlArray.length; row++) {
      var a = htmlArray[row].split('=');

      if (a.length > 1) {
        objData[a[0]] = decodeURIComponent(a[1]);
      }
    }
    return objData;
  }
  /* 数字千分位展示 */
  static formatNumber(num){
    if(!num||num==='0'||isNaN(Number(num))){
      return formatWithThousandsSeparator(0)
    }
    if(num<1){
      return num
    }
    return formatWithThousandsSeparator(Math.round(num))
  }
  /* 自定义四舍五入展示 */
  static customRound(num) {
    if(!num||num==='0'||isNaN(Number(num))){
      return num
    }
    if(num<1){
      return num
    }
    return Math.round(num)
  }
}
